module.exports = __webpack_public_path__ + "img/A3-6-plan.e8d37bdf.png";